import { Alert, Button } from "@mui/material";
import courseImage from "src/Common/CourseImage";

interface Courses {
    courseId: number;
    courseName: string;
    courseDescription: string;
    percentage: number;
    images: string;
    packageId: number;
    courseVideoCount: number;
    purchased: boolean;
    onServer:boolean;
}
interface MyCoursePackagesProps {
    courses: Courses[];
    setShowModule: (module: string) => void;
    firstStepPercentage: number;
    courseStartLearning
}
const MyCoursesDisplay: React.FC<MyCoursePackagesProps> = (
    {
        courses,
        courseStartLearning,
        firstStepPercentage,
        setShowModule,
    }
) => {
    return (
        <div style={{ background: "black" }}>
            {(
                <ul className="list-group" style={{ gap: "20px" }}>
                    <div style={{ background: "black" }}>
                        <Button onClick={() => { (setShowModule("package")) }} style={{ borderRadius: "20px", color: "white", background: "#343434" }}><i className="fa-solid fa-arrow-left"></i></Button>
                    </div>
                    <div className="myCoursesPackage">
                        {courses.map((course) => (
                            <>
                                <div
                                    style={{
                                        width: "100%",
                                        height: "auto",
                                        padding: "0",
                                        position: "relative",
                                        display: "block",
                                    }}
                                >
                                    <div
                                        className="categories"
                                    >
                                        <img className="img-fluid posterShow" src={courseImage.find(data => data.courseId === course.courseId)?.posterLink} alt={course.images} />
                                    </div>
                                    <div
                                        style={{
                                            marginTop: "-25px",
                                            backgroundColor: "rgba(255, 255, 255, 0.8)",  // Slightly transparent white background for readability
                                            width: "100%",
                                            textAlign: "left",
                                            color: "black",
                                            height: "300px",
                                        }}
                                    >
                                        <h5 style={{ textAlign: "center", background: "black", color: "white" }}>{course.courseName}</h5>
                                        <div style={{ display: "flex", flexDirection: "column", height: "80%", justifyContent: "space-between" }}>
                                            <p style={{ fontSize: "15px" }}>{course.courseDescription}</p>
                                            <div style={{ display: "flex", justifyContent: "center", padding: "10px" }}>
                                                {
                                                    course.courseVideoCount > 0 ?
                                                        <>
                                                            {course.purchased ?
                                                                <>
                                                                    {
                                                                        firstStepPercentage < 95 ?
                                                                            <>
                                                                                <div
                                                                                    style={{
                                                                                        padding: '20px',
                                                                                        backgroundColor: '#ffffff',
                                                                                        border: '2px solid #0073e6', // Professional blue tone
                                                                                        borderRadius: '12px',
                                                                                        fontSize: '18px',
                                                                                        fontWeight: '600',
                                                                                        fontFamily: 'Segoe UI, Arial, sans-serif', // Modern font
                                                                                        color: '#003366', // Deep navy for a sophisticated look
                                                                                        textAlign: 'center',
                                                                                        width: '400px',
                                                                                        margin: '30px auto',
                                                                                        boxShadow: '0px 6px 12px rgba(0, 115, 230, 0.15)', // Subtle shadow
                                                                                    }}
                                                                                >
                                                                                    First Step Pending
                                                                                </div>

                                                                            </>
                                                                            :
                                                                            <>
                                                                                {
                                                                                    course.percentage > 0 ?
                                                                                        <Button
                                                                                            onClick={() => courseStartLearning(course)}
                                                                                            style={{
                                                                                                borderRadius: '20px',
                                                                                                color: 'white',
                                                                                                padding: '10px 20px',
                                                                                                fontWeight: 'bold',
                                                                                                fontSize: '16px',
                                                                                                backgroundColor: '#0073e6', // Professional blue tone
                                                                                                border: 'none',
                                                                                                cursor: 'pointer',
                                                                                                boxShadow: '0px 4px 8px rgba(0, 115, 230, 0.2)',
                                                                                                transition: 'background-color 0.3s ease',
                                                                                            }}
                                                                                        >
                                                                                            Resume Course ({course.percentage}%)
                                                                                        </Button>
                                                                                        :
                                                                                        <Button
                                                                                            onClick={() => courseStartLearning(course)}
                                                                                            style={{
                                                                                                borderRadius: '20px',
                                                                                                color: 'white',
                                                                                                padding: '10px 20px',
                                                                                                fontWeight: 'bold',
                                                                                                fontSize: '16px',
                                                                                                backgroundColor: '#28a745', // Green tone for "Start"
                                                                                                border: 'none',
                                                                                                cursor: 'pointer',
                                                                                                boxShadow: '0px 4px 8px rgba(0, 115, 230, 0.2)',
                                                                                                transition: 'background-color 0.3s ease',
                                                                                            }}
                                                                                        >
                                                                                            Start Course
                                                                                        </Button>

                                                                                }
                                                                            </>
                                                                    }
                                                                </> :
                                                                <Button style={{ background: "#4187AD", color: "white", borderRadius: "10px" }}>Buy Now<i className="fa fa-shopping-cart" aria-hidden="true"></i></Button>
                                                            }
                                                        </>
                                                        :
                                                        <Button
                                                            style={{
                                                                background: "#4187AD",
                                                                color: "white",
                                                                borderRadius: "10px",
                                                                padding: "10px 20px",
                                                                border: "none",
                                                                cursor: "pointer",
                                                                fontSize: "16px",
                                                                transition: "background 0.3s ease",
                                                                gap: "10px"
                                                            }}
                                                        >
                                                            Coming Soon <i className="fa fa-clock" aria-hidden="true"></i>
                                                        </Button>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        ))}
                    </div>
                    <div>
                        <Button onClick={() => { (setShowModule("package")) }} style={{ borderRadius: "20px", color: "white", background: "#343434" }}><i className="fa-solid fa-arrow-left"></i></Button>
                    </div>
                </ul>
            )}
        </div>
    );
}
export default MyCoursesDisplay;